export default __webpack_public_path__ + "static/media/Software.8dc8e62c.svg";